import React, { useEffect, useState } from 'react';
import { Package, Subjects } from 'pages/newSubscription/models';
import { AppPath } from 'appConstants';
import { useLocation } from '@reach/router';

type Props = {
  subjectInfo: Subjects;
  selectPackage: (p: Package) => void;
  selectedPackages: Package[];
  ageGroup: string;
};

const PackageCard: React.FC<Props> = ({
  subjectInfo,
  selectPackage,
  selectedPackages,
  ageGroup,
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const { isAvailableForSchool } = subjectInfo.subscriptions[0];

  useEffect(() => {
    const packageCardSelected = selectedPackages.find(
      (p: Package) => p.ageGroup === ageGroup && p.subject === subjectInfo.name
    );
    setIsChecked(packageCardSelected ? true : false);
  }, [selectedPackages]);

  const togglePackageCard = () => {
    setIsChecked((prevState) => !prevState);
    const selectedPackage = subjectInfo.subscriptions[0];
    selectedPackage &&
      selectPackage({
        ...selectedPackage,
        ageGroup,
        subject: subjectInfo.name,
      });
  };

  return (
    <div
      className={`PackageCard ${isChecked ? 'Checked' : 'Unchecked'} ${
        pathname === AppPath.NEW_FREE_TRIAL &&
        !isAvailableForSchool &&
        'Disabled'
      }`}
    >
      <div
        className="FreeTrialCardContent"
        onClick={
          pathname === AppPath.NEW_FREE_TRIAL
            ? isAvailableForSchool
              ? togglePackageCard
              : () => {}
            : togglePackageCard
        }
      >
        <span className="Checkbox"></span>

        <div className="Details">
          <h3>{subjectInfo.name}</h3>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
